import React from "react";
import AdminHeader from "./AdminHeader";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  return (
    <div style={{ display: "flex", height: "100vh", flexDirection: "column" }}>
      <AdminHeader />
      <div style={{ display: "flex", flex: 1 }}>
        <Sidebar />

        <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
